import React, { Component } from "react";
import ApplyNewFlow from "../pages/ApplyNewFlow";

/** Catch render crashes so /apply-new never stays a white blank screen */
class ApplyNewErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ApplyNew crashed:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: "sans-serif", maxWidth: 480, margin: "40px auto" }}>
          <h1 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h1>
          <p style={{ color: "#64748b", marginBottom: 16 }}>
            The apply form failed to load. Please refresh or try again.
          </p>
          <pre
            style={{
              background: "#f8fafc",
              padding: 12,
              borderRadius: 8,
              fontSize: 12,
              overflow: "auto",
              whiteSpace: "pre-wrap",
            }}
          >
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <button
            type="button"
            onClick={() => {
              try {
                localStorage.clear();
                sessionStorage.clear();
              } catch {
                /* ignore */
              }
              window.location.assign("/apply-new");
            }}
            style={{
              marginTop: 16,
              padding: "10px 16px",
              border: 0,
              borderRadius: 8,
              background: "#591703",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Reset &amp; Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

/** New Fundswalle automation UI — live /apply-now is untouched */
const ApplyNew = () => (
  <ApplyNewErrorBoundary>
    <ApplyNewFlow />
  </ApplyNewErrorBoundary>
);

export default ApplyNew;
